import { db } from "@/database/db";

const getAccessPermission = await db.permission.get("access-permission-info");

export function isAllowedToShow(permission:any) {
  const listAllowed = [
    'total-user',
    'total-item',
    'item-by-category',
    'item-by-group-category',
    'total-vessel'
  ];

   return listAllowed.includes(permission);
}

export function formatDate(dateString: string) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
}

export function formatDateTime(date: string) {
  const isoDate = date;
  const formattedDate = new Date(isoDate).toLocaleString();

  return formattedDate;
}

export function mapOptionMultiselectWithAll(
  list = [],
  valueKey = "id",
  labelKey = "name",
  labelOptional = ""
) {
  if (list != null) {
    if (!Array.isArray(list)) {
      return [{ value: 'All', label: 'All' }, { value: list[valueKey], label: list[labelKey] }];
    }
    const mappedList = list.map((element: any) => ({
      value: element[valueKey],
      label:
        labelOptional !== ''
          ? `${element[labelKey]} (${element[labelOptional]})`
          : element[labelKey],
    }));
    return [{ value: 'All', label: 'All' }, ...mappedList];
  }
  return [];
}


export function mapOptionMultiselect(
  list = [],
  valueKey = "id",
  labelKey = "name",
  labelOptional = "",
) {

  if (list != null){
    if (!Array.isArray(list)) {
      return {value: list[valueKey], label:list[labelKey]};
    }

    return list.map((element: any) => ({
      value: element[valueKey],
      label: labelOptional != '' ? element[labelKey] +  ' (' + element[labelOptional] + ')' : element[labelKey],
    }));
  }

}

export async function urlToObject(image = "") {
  const response = await fetch(image, { mode: "no-cors" });
  const blob = await response.blob();
  const file = new File([blob], "image.jpg", { type: blob.type });
  return file;
}

interface TreeNode {
  text: string;
  children: string[];
  permission_code: number;
  status: boolean;
}

export function collectLevelOneIds(data : any[]) {
  return data
    .filter(item => item.parent_id === null)
    .map(item => 'id'+item.id);
}

export function convertToTreeFormat(data: any[]): Record<string, TreeNode> {
  const tree: Record<string, TreeNode> = {};

  function processItem(item: any): string {
    const id = `id${item.id}`;
    tree[id] = {
      text: item.name,
      children: item.sub_menu ? item.sub_menu.map(processItem) : [],
      permission_code: item.permission_code,
      status: item.status
    };
    return id;
  }

  data.forEach(item => processItem(item));

  return tree;
}

export function getBadgeClassStatusRequisition(status: string) {
  const classify = ((status: string) => {
    if (status.includes('draft')) return 'draft';
    else if (status.includes('waiting')) return 'waiting approval';
    else if (status.includes('approved')) return 'approved';
    else if (status.includes('decline')) return 'decline';
    else if (status.includes('revision')) return 'revision';
    else if (status.includes('complete')) return 'complete';
  });

  let result = '';
  switch (classify(status.toLowerCase())) {
    case 'draft':
      result = 'badge bg-secondary text-white p-2 fs-12 fw-normal';
      break;
    case 'waiting approval':
      result = 'badge bg-warning text-white p-2 fs-12 fw-normal';
      break;
    case 'approved':
      result = 'badge bg-primary text-white p-2 fs-12 fw-normal';
      break;
    case 'decline':
      result = 'badge bg-danger text-white p-2 fs-12 fw-normal';
      break;
    case 'revision':
      result = 'badge bg-info text-white p-2 fs-12 fw-normal';
      break;
    case 'complete':
      result = 'badge bg-success text-white p-2 fs-12 fw-normal';
      break;

    default:
      result = 'badge bg-primary text-white p-2 fs-12 fw-normal';
      break;
  }
  return result;
}

export function getBadgeClassUrgencyRequisition(priority: string) {
  let result = '';
  switch (priority.toLocaleLowerCase()) {
    case 'regular':
      result = 'badge bg-warning text-white p-2 fs-12 fw-normal';
      break;
    case 'urgent':
      result = 'badge bg-danger text-white p-2 fs-12 fw-normal';
      break;

    default:
      result = 'badge bg-warning text-white p-2 fs-12 fw-normal';
      break;
  }
  return result;
}

export function hasAccess(access_code: string) {
  const accessPermission: any = getAccessPermission?.data;
  
  if (accessPermission.includes(access_code)) return true;
  return false;
}
